/**
 * sorts passed in array alphabetical by name field
 * @param  {Array.Object} items  array to to sort
 * @return {Array.Object}      alphabetically sorted items;
 */

const sortByName = items =>
  items.sort((a, b) => {
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    return 0;
  });

export default sortByName;
